import { createContext, useContext } from 'react';

import type {
	ReportCharacterParams,
	ReportMediaParams,
	ReportMessageParams,
} from '~features/report';

export enum ReportMessageSource {
	RightClick = 'right_click',
	LongClick = 'long_tap',
	Button = 'three_dot_icon',
}

export type TReportActionsState = {
	reportMessage: (arg: ReportMessageParams) => () => void;
	reportCharacter: (arg: ReportCharacterParams) => () => void;
	reportMedia: (arg: ReportMediaParams) => () => void;
};

export const ReportActionsContext = createContext<TReportActionsState>({
	reportMessage: () => () => undefined,
	reportCharacter: () => () => undefined,
	reportMedia: () => () => undefined,
});

export const useReportActionsContext = () => {
	const context = useContext(ReportActionsContext);
	if (!context) {
		throw Error('ReportActionsContext context no context Provider');
	}
	return context;
};
